export default __webpack_public_path__ + "static/media/logo.6e56b34e.png";